
























































































































import {
  Vue, Component, Prop, Emit,
} from 'vue-property-decorator';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import { VbLoadingService } from '@/shared/loading/loading.service';
import { VbPagination } from '@/shared/pagination/pagination.component.vue';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import MainButton from '@/shared/buttons/main-button.component.vue';
import splitContent from '@/shared/directive/split-content';
import DateHandler from '@/shared/utils/date-format';
import BindInstance from '@/domain/contract/entity/bind-instance.entity';
import Contract from '@/domain/contract/entity/contract.entity';
import ContractService from '@/domain/contract/service/contract.service';
import ModalWarning from '@/shared/modal/modal-warning.component.vue';
import ContractLink from '@/domain/contract/entity/contract-link.entity';
import Header from './header.json';
import Pagination from '../../../../domain/pagination.entity';
import ContractInfoModalNewLink from '../contract-into-modal-new-link.component.vue';

@Component({
  components: {
    MainButton,
    VbPagination,
    ModalWarning,
    VbTooltipSlot,
    ContractInfoModalNewLink,
  },
  filters: {
    splitContent,
    formatDate(value: string) {
      return DateHandler.simpleDate(value);
    },
    formatLink(value: string) {
      return value.length < 50 ? value : `${value.substring(0, 60)}...`;
    },
  },
})

export default class Links extends Vue {
  @Prop({
    required: false,
    default: 'auto',
  })
  tableHeight!: string;

  @Prop({ required: true }) contract!: Contract;

  @Prop({
    required: false,
    default: true,
  })
  border!: boolean;

  @Prop({
    required: true,
  })
  contractId!: string;

  @Prop() isAdministratorOrSupervisor!: boolean;

  @Prop({
    required: true,
  })
  pagination!: Pagination;

  @Prop({
    required: true,
  })
  links!: ContractLink[];

  persistLink: ContractLink = ContractLink.of({});

  updateLinkModal: boolean = false;

  updateLinkModalKey: number = 0;

  persistBindLink: BindInstance = BindInstance.of({});

  header = Header;

  warningModalValue: boolean = false;

  warningMessage: string = '';

  deleteLinkId: string = '';

  newLinkModal: boolean = false;

  updateWarningModalState(value: boolean): void {
    this.warningModalValue = value;
  }

  concludedAt(value: string) {
    return value ? DateHandler.timestampToLocal(value) : '-';
  }

  setDeleteLinkId(linkId: string): void {
    this.deleteLinkId = linkId;
  }

  setDeleteWarningMessage(): void {
    this.warningMessage = 'Deseja realmente <strong style="color: orange">remover</strong> o link? '
      + 'Ao clicar no botão Sim, as alterações serão imediatamente realizadas.';
  }

  showWarningModal(): void {
    this.updateWarningModalState(true);
  }

  updateLinks() {
    this.$emit('updateLinks');
  }

  deleteLink(): void {
    ContractService.deleteLink(this.deleteLinkId)
      .then((response) => {
        this.updateLinks();
      })
      .catch((err: any) => VbSnackbarService.handleHttpError(err))
      .finally(() => {
        this.deleteLinkId = '';
        this.warningMessage = '';
        this.updateWarningModalState(false);
        VbSnackbarService.showSuccess('Link removido com sucesso');
      });
  }

  updateTable(pagination: Pagination): void {
    this.$emit('update:pagination', pagination)
  }

  updateSortBy(sortBy: string[]): void {
    this.updateTable(new Pagination({ ...this.pagination, sortBy }))
  }

  updateSortDesc(sortDesc: string[]): void {
    this.updateTable(new Pagination({ ...this.pagination, sortDesc }))
  }

  updateLinkModalValue(value: boolean): void {
    this.updateLinkModalKey = value ? this.updateLinkModalKey + 1 : this.updateLinkModalKey;
    this.updateLinkModal = value;
  }

  editLink(link: ContractLink) {
    ContractService.updateLink(link).then(() => {
      VbSnackbarService.showSuccess('Link editado com sucesso!');
      this.updateLinkModal = false;
    }).catch((error) => VbSnackbarService.handleHttpError(error)).finally(() => {
      this.updateLinks();
    });
  }

  clickEditLink(link: ContractLink): void {
    this.persistLink = ContractLink.of(link);
    this.updateLinkModalValue(true);
  }

  redirectLink(link: string) {
    window.open(link, '_blank');
  }

  saveLink(link: ContractLink) {
    ContractService.createLink(this.contract.id, link).then(() => {
      VbSnackbarService.showSuccess('Link criado com sucesso!');
      this.newLinkModal = false;
    })
      .catch(VbSnackbarService.handleHttpError)
      .finally(() => { this.updateLinks(); });
  }

  createNewLink(): void {
    this.updateLinkModalValue(true);
    this.persistLink = ContractLink.of({})
  }
}
